module.exports = __webpack_public_path__ + "static/trave3-a8ae9f8c514032e6844b51d108002e1c.jpg";